module.exports = __webpack_public_path__ + "img/qa_open.b4f9a1c2.png";